import { connect } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';

import { PERMISSION } from 'constants/logic';
import { selectActiveVenueId, selectUserHasPermission } from 'selectors/general';
import { selectOpportunities, selectOpportunitiesTeaserMeta } from './Opportunities.selectors';

import OpportunitiesTeaser from './OpportunitiesTeaser';

export const mapStateToProps = state => {
  const venueId = selectActiveVenueId(state);
  const { data: opportunities, isLoaded } = selectOpportunities(state);
  const { hasInitial, status: opportunitiesStatus } = selectOpportunitiesTeaserMeta(state);

  return {
    hasPermission: selectUserHasPermission(state, PERMISSION.DISPLAY_SPOT_MANAGEMENT),
    isLoaded,
    opportunities,
    opportunitiesStatus,
    showEmpty: hasInitial && isLoaded && _isEmpty(opportunities),
    venueId,
  };
};

export default connect(mapStateToProps)(OpportunitiesTeaser);
